import React, { createContext, useCallback, useContext, useState } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "../../../../shared/helper/UIHelpers";

const DatasetStorageTypeUIContext = createContext();

export function useDatasetStorageTypeUIContext() {
  return useContext(DatasetStorageTypeUIContext);
}

export function DatasetStorageTypeUIProvider({
  datasetStorageTypeUIEvents,
  children
}) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback(nextQueryParams => {
    setQueryParamsBase(prevQueryParams => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParams,
    newDatasetStorageTypeButtonClick:
      datasetStorageTypeUIEvents.newDatasetStorageTypeButtonClick,
    openChangeStatusDialog: datasetStorageTypeUIEvents.openChangeStatusDialog,
    openEditDatasetStorageTypeDialog:
      datasetStorageTypeUIEvents.openEditDatasetStorageTypeDialog
  };

  return (
    <DatasetStorageTypeUIContext.Provider value={value}>
      {children}
    </DatasetStorageTypeUIContext.Provider>
  );
}
